<div class="car-card-horizontal" (click)="goToCarDetailsPage(car.carId, car.offerId)">
  <div class="car-section">
    <div class="car-image">
      @if (carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0) {
        <p class="spinner">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>
      }
      <img [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.webp'" alt="Car Image">
      <div class = "img-arrow-container">
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="prevImage();$event.stopPropagation()" class="pic-arrow-left"><mat-icon>arrow_back_ios</mat-icon></button>
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="nextImage();$event.stopPropagation()" class="pic-arrow-right"><mat-icon>arrow_forward_ios</mat-icon></button>
      </div>

      @if ((carImagesFolder != undefined && carImagesFolder!.length > 0)) {
        <div class = "img-counter">
          {{ currentImageIndex + 1 }}/{{ carImagesFolder!.length }}
        </div>
      }

      <!--
      <p>
        Download Progress = {{ progressInfos[i] }} and message Message = {{message[i]}}
      </p>
      -->

    </div>

    <div class="car-data">
      <div class = "car-make-model-actions">
        <h4>{{car.make}} {{car.model}} {{car.version }}<span class="car-version">  {{car.year}}</span></h4>
        <div class="dealer-actions">
          @if (!isProvider) {
            <button class="simple-button-{{businessLine!.toLowerCase()}}" mat-button matTooltipPosition="above" matTooltip="Favorite" (click)="toggleFavorite(car.carId, car.offerId);$event.stopPropagation()"><mat-icon>{{car.favorite? "favorite": "favorite_outline"}} </mat-icon></button>
          }
          <button class="simple-button-{{businessLine!.toLowerCase()}}" mat-button matTooltipPosition="above" matTooltip="Share"><mat-icon>share</mat-icon></button>
        </div>
      </div>
      <h6> @for (ft of car.features; track ft; let i = $index) {
        <span> @if (i>0) {
          <span>,</span>
        } {{ft}} </span>
      }</h6>
      <h6>{{ car.offerTitle }} - {{ car.offerDescription }}</h6>

      @if (car !== undefined) {
        <div class="car-price-location">
          <h3>
            {{ moneyFormat(""+$safeNavigationMigration(car?.getCarPrice(businessLine!)?.amount)) }}
            <span class="price-currency"> {{ car?.getCarPrice(businessLine!)?.currency }}
              @if (businessLine== CarBusinessLine.RENT) {
                <span>/J </span>
              }
            </span>
            @if (businessLine== CarBusinessLine.RENT) {
              <span>
                <button mat-button class="simple-button-{{businessLine!.toLowerCase()}}"
                  (click)="showBookingCalendar = !showBookingCalendar;$event.stopPropagation()"
                  cdkOverlayOrigin #trigger1="cdkOverlayOrigin">
                  <mat-icon>date_range</mat-icon> <h6>Disponibilités</h6>
                </button>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="trigger1"
                  [cdkConnectedOverlayOpen]="showBookingCalendar">
                  <div class="overlay-box">
                    <!--
                    <h6 *ngFor="let booking of car.bookings ; index as i">
                      {{ dateFormat(booking.startDate) }} - {{ dateFormat(booking.endDate) }} - {{booking.status}}
                    </h6>
                    -->
                    <mat-calendar [dateFilter]="filterBookedDates" >
                    </mat-calendar>
                    <button mat-button class="simple-button-{{businessLine!.toLowerCase()}}"  (click)="showBookingCalendar = !showBookingCalendar; $event.stopPropagation()" ><b> Fermer </b><mat-icon>close</mat-icon></button>
                  </div>
                </ng-template>
              </span>
            }
          </h3>
          <div class="car-location">
            {{ car.city }} &nbsp;
            <img class="mini-flag" src="assets/images/country-flags/{{car.country}}.png" alt="{{car.country}}">
          </div>
        </div>
      }

      <mat-divider class="div1"></mat-divider>

      <div class="key-details">
        {{car.mileage}} km . {{car.gearBox }} . {{car.fuel}} . {{car.powerHp}} cv
        <!-- <span class="section-separator"> &nbsp; | &nbsp; </span>
        <div>{{car.fuel}} | {{car.powerHp}} Hp</div> -->
      </div>
      {{car.actions}}
      <div class="dealer-actions">


        @if (!car.provider) {
          <div class="button-section" >
            <!-- <button type="submit" mat-button class="cta-button"> <mat-icon>phone_enabled</mat-icon> Contacter Vendeur </button> -->
            @if (businessLine==CarBusinessLine.BUY && (! loggedInUser.partner || loggedInUser.keepOffer.servicesProvided.includes(ServiceType.BUY) )) {
              <button type="submit" mat-button class="cta-button-buy"
                (click)="openProposalDialog();$event.stopPropagation()">
                <mat-icon>attach_money</mat-icon> {{car.proposals.length > 0 ? 'Editer ' : 'Faire une '}}offre
              </button>
            }
            @if (businessLine==CarBusinessLine.RENT) {
              <button type="submit" mat-button class="cta-button-rent"
                (click)="openBookingDialog();$event.stopPropagation()">
                <mat-icon>attach_money</mat-icon> {{car.myBookings.length > 0 ? 'Editer réservation' : 'Réserver'}}
              </button>
            }
            <!-- <button *ngIf="car.favorite" mat-button class="cta-button-{{businessLine?.toLowerCase()}}"> <mat-icon>share</mat-icon>Partager</button> -->
            <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" matTooltipPosition="above" matTooltip="Email Seller" (click)="openMessageDialog();$event.stopPropagation()" >
              <mat-icon>mail</mat-icon> Contacter Vendeur
            </button>
          </div>
        }

        @if (car.customer) {
          <div class="button-section">
            <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" (click)="goToCustomerPage();$event.stopPropagation()">
              <mat-icon>edit</mat-icon>Gérer {{ businessLine == CarBusinessLine .BUY ? 'achat' : 'réservation'}}
            </button>
            <!-- <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}"> <mat-icon>share</mat-icon>Partager</button>
            <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" [routerLink]="['/customer/buy']" fragment="{{car.carId}}">
              <mat-icon>edit</mat-icon>Editer
            </button> -->
          </div>
        }

        @if (car.provider) {
          <div class="button-section">
            <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" (click)="goToProviderPage();$event.stopPropagation()">
              <mat-icon>edit</mat-icon>Gérer {{ businessLine == CarBusinessLine .BUY ? 'vente' : 'location'}}
            </button>
            <!--  <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}"> <mat-icon>share</mat-icon>Partager</button>
            <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" [routerLink]="['/customer/buy']" fragment="{{car.carId}}">
              <mat-icon>edit</mat-icon>Editer
            </button> -->
          </div>
        }

        @if (businessLine===CarBusinessLine.BUY && !car.provider && !car.customer && loggedInUser.partner) {
          <div class="button-section">
            <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" (click)="openJobDialog(ServiceType.INTERMEDIATION);$event.stopPropagation()">
              <mat-icon>edit</mat-icon>Proposer intermédiation
            </button>
          </div>
        }

        @if (businessLine===CarBusinessLine.BUY && car.provider && ! loggedInUser.partner) {
          <div class="button-section">
            <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" (click)="openJobDialog(ServiceType.INTERMEDIATION);$event.stopPropagation()">
              <mat-icon>edit</mat-icon>Demander intermédiation
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="seller-section">
    <mat-divider></mat-divider>
    <!--
    <p>
      Seller: <button mat-button matTooltipPosition="above" matTooltip="View dealer details" (click)="goToSellerPage(car.providerId);$event.stopPropagation()"> {{ car.providerId }} </button>
      and car Id : {{car.carId}}

    </p>

    <p>
      Created: {{dateFormat(car.created)}},  Last Updated: {{dateFormat(car.lastUpdated)}}
    </p> -->
    <div class="seller-section-details">

      <h6> {{businessLine== CarBusinessLine.BUY ? 'Vendu' : 'Loué'}} par
        <button mat-button matTooltipPosition="above" matTooltip="View dealer details"
          (click)="goToSellerPage(car.providerId);$event.stopPropagation()"
          class="simple-button">
          <mat-icon>{{(car.providerType==DealerType.PROFESSIONAL) ? 'domain' : 'person'}} </mat-icon>
          @if (isProvider) {
            <span>Moi</span>
          }
          @if (!isProvider) {
            <span>
              @if (car.providerType==DealerType.PROFESSIONAL) {
                <span>
                  {{ car.providerBusinessName }}
                </span>
              }
              @if (car.providerType!=DealerType.PROFESSIONAL) {
                <span>
                  {{ car.providerName }}
                </span>
              }
            </span>
          }
        </button>
      </h6>
      <span class="section-separator"> &nbsp;| &nbsp; </span>
      <h6> <span class="label">Avis clients: </span>
      <button mat-button matTooltipPosition="above" matTooltip="View dealer details"
        (click)="goToSellerPage(car.providerId);$event.stopPropagation()"
        class="simple-button" disabled>
        @for (r of car.providerRatingsSummary.indicators; track r; let i = $index) {
          <span>
            <!--{{currentProvider.ratingsCounts[i]}}
            <mat-icon *ngIf="r===1">star</mat-icon>
            <mat-icon *ngIf="r!==1"> {{r===0?'star_outlined':'star_half'}}</mat-icon> -->
            @if (r===1) {
              <mat-icon>star</mat-icon>
            }
            @if (r!==1) {
              <mat-icon> {{r===0?'star_outlined':'star_half'}}</mat-icon>
            }
          </span>
        }

        <b>{{ car.providerRatingsSummary.average.toFixed(2)}} </b>

        <mat-icon (click)="showDetails = !showDetails;$event.stopPropagation()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">info</mat-icon>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="showDetails">

          <div class="ratings-details">
            <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon>({{car.providerRatingsSummary.counts[4]}})</h6>
            <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[3]}})</h6>
            <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[2]}})</h6>
            <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[1]}})</h6>
            <h6><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[0]}})</h6>
          </div>
        </ng-template>
        ({{ getSellerRatingsTotalCount()}} avis)
      </button>
    </h6>

  </div>
  <!-- <div>Postée le {{dateFormat(car.created)}}</div>  -->
</div>
</div>
